/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type InvoicesListDisputeStatusItem = typeof InvoicesListDisputeStatusItem[keyof typeof InvoicesListDisputeStatusItem];


export const InvoicesListDisputeStatusItem = {
  active: 'active',
  'awaiting-vendor': 'awaiting-vendor',
  none: 'none',
  resolved: 'resolved',
  withdrawn: 'withdrawn',
} as const;
